import { fabric } from 'fabric';

import theme from '~/theme/theme';

const {
  drawingTool: {
    secondaryBorderColor,
    drawingShape: { stroke },
  },
} = theme.light;

export const updateElementStroke =
  (isActive: boolean) =>
  (element: fabric.Object): void => {
    const strokeColor = isActive ? secondaryBorderColor : stroke.normal;

    element.set({ stroke: strokeColor });
  };
